import gql from "graphql-tag";

export const MY_LEAVE_SUBSCRIPTION_EMAILS_BY_COMPANY = gql`
  subscription getEmailsByCompanyList {
    getEmailsByCompanyList {
      companyCode
      type
      address
    }
  }
`;
